import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const interestSchema = itemSchema.extend({
  name: z.string().min(1),
  keywords: z.array(z.string()).default([]),
});

export const minimalInterestSchema = interestSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Interest = z.infer<typeof interestSchema>;
export type MinimalInterest = z.infer<typeof minimalInterestSchema>;

// Defaults
export const defaultInterest: Interest = {
  ...defaultItem,
  name: "",
  keywords: [],
};

export const deminimalizeInterest = (interest: MinimalInterest): Interest => {
  return {
    ...defaultInterest,
    ...interest,
    id: createId(),
  };
};
